import React from 'react';

export const useCompareWindowWidth = (width: number) => {
	const [currentWidth, setCurrentWidth] = React.useState(window.innerWidth);
	const previousWidth = React.useRef(currentWidth);

	React.useEffect(() => {
		const handleResize = () => {
			const newWidth = window.innerWidth;
			if (newWidth !== previousWidth.current) {
				setCurrentWidth(newWidth);
				previousWidth.current = newWidth;
			}
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return React.useMemo(() => currentWidth < width, [currentWidth, width]);
};
